import DataBlock from '../data_block';

var base64js = require('base64-js');

export default class Layer {
  constructor(page) {
    this.page = page;
    this.type = 'image';

    this.name = '';

    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;

    this.canvas = null;
    this.opacity = 1.0;
    this.visible = true;
    this.blendingMode = 'source-over';
  }

  render(ctx) {
    if (!this.canvas || this.visible === false)
      return;

    ctx.globalCompositeOperation = this.blendingMode;
    ctx.globalAlpha = this.opacity;
    ctx.drawImage(this.canvas, this.x, this.y, this.width, this.height);
  }

  isSelected() {
    return this.page.selectedLayer == this;
  }

  select() {
    this.page.selectLayer(this);
  }

  toggleVisibility() {
    this.visible = !this.visible;
    this.page.update();
    this.page.triggerEvent('update');
  }

  remove() {
    this.page.removeLayer(this);
  }

  __exportBinary(extra) {
    let header = new DataBlock();
    header.put4(this.id);
    header.putString(this.type);
    header.putString(this.name);

    header.putDouble(this.x);
    header.putDouble(this.y);
    header.putDouble(this.width);
    header.putDouble(this.height);

    header.putDouble(this.opacity);
    header.put(this.visible ? 1 : 0);
    header.putString(this.blendingMode);

    let imageData = [];
    let compression = 1; // 1 = PackBits(data-url)
    if (this.canvas) {
      imageData = base64js.toByteArray(this.canvas.toDataURL('image/png').substring('data:image/png;base64,'.length));
    }

    if (!extra) {
      extra = [];
    }

    header.put4(imageData.length);
    header.put4(extra.length);

    let data = new DataBlock();
    data.put(header);
    data.put(imageData);
    data.put(extra);

    return data;
  }

  exportBinary() {
    return this.__exportBinary([])
  }
}

